enum ProjectCriteriaOptions {
  PROJECTS_NEEDS_CONTRACTORS = "Need contractors",
  PROJECTS_WITHOUT_MANAGER = "Without managers",
  PROJECTS_WITHOUT_ACTIVITIES = "Without activities",
}

export default ProjectCriteriaOptions;